(function (itxApp) {

    'use strict';
    /**
     * itx-hide-categories-related='id de categoria'
     * Oculta/Muestra los 'li' que están contenidos en el mismo 'ul', y que tengan la clase aplicada 'related-{{id de categoria}}}' 
     * el li pulsado debe tener en su las el 'id de categoria', sin 'related-'
     * Para comprobar si debe mostrar u ocultar, comprueba si tiene aplicada clase 'informative-uncollapsed' el 'li' pulsado.
     * clases de css que intervienen:
     * informative ('li' informativos, que serán los colapsen, descolapsen)
     * informative-uncollapsed y informative-collapsed ('li' informativos colapsados y descolapsados)
     * related ('li' de categorias que pertenecen a 'li' informativos)
     * related-{{id de informativo}}} ('li' de categoria que pertenece a un 'li' informativo en concreto)
     */
    angular.module('itxApp.common')
        .directive('itxHideCategoriesRelated', ItxHideCategoriesRelatedDrt);

    function ItxHideCategoriesRelatedDrt() {
        return {
            restrict: 'A',
            replace: false,
            transclude: false,
            link: function (scope, iElement, attrs) {               
                iElement.bind('click', function() {
                    var collaps = $($('li.'+attrs.itxHideCategoriesRelated, $(iElement).closest('ul'))[0]).hasClass('informative-uncollapsed');
                    $('li.related', $(iElement).closest('ul')).addClass('hide');// oculatamos todos los marcados con clase related
                    $('li.informative', $(iElement).closest('ul')).addClass('informative-collapsed').removeClass('hide').removeClass('informative-uncollapsed');//colapsamos todos
                    if(collaps){
                        $('li.'+attrs.itxHideCategoriesRelated).addClass('informative-collapsed');
                        $('li.related-'+attrs.itxHideCategoriesRelated, $(iElement).closest('ul')).addClass('hide');
                    }else{
                        $('li.'+attrs.itxHideCategoriesRelated).addClass('informative-uncollapsed');//descolapsamos el clickado
                        $('li.related-'+attrs.itxHideCategoriesRelated, $(iElement).closest('ul')).removeClass('hide');
                        $('li.related-'+attrs.itxHideCategoriesRelated+' ul li', $(iElement).closest('ul')).removeClass('hide');
                    }
                });
                 
            }
        };
    }

    /** Public */
    itxApp.common.ItxHideCategoriesRelatedDrt = ItxHideCategoriesRelatedDrt;

})(window.itxApp);